var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"height--100__abs width--100 flex flex--center"},[_c('LoginBox')],1)}
var staticRenderFns = []

export { render, staticRenderFns }